var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36315 7.70709C6.75794 8.09764 7.39907 8.09764 7.79385 7.70709L13.8578 1.70826C14.2525 1.31771 14.2525 0.68346 13.8578 0.292911C13.463 -0.0976377 12.8218 -0.0976377 12.4271 0.292911L7.07692 5.58563L1.72679 0.296036C1.33201 -0.094513 0.690874 -0.094513 0.296089 0.296036C-0.0986967 0.686584 -0.0986967 1.32084 0.296089 1.71138L6.35999 7.71021L6.36315 7.70709Z",
    fill: "#BF96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIndicator);
export default __webpack_public_path__ + "static/media/dropdown-indicator.d572d3dff04b9024325d02fb5f4f95c9.svg";
export { ForwardRef as ReactComponent };